import { FetchResult } from '@apollo/client'
import { GenerateCustomerTokenPayload } from 'lib/core/data/customer/token/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface GenerateCustomTokenMutationObject {
  mutation: {
    generateCustomerToken: {
      __args: {
        email: string
        password: string
        persistent?: boolean
      }
      token: boolean
      expiration_date: boolean
      expiration_timestamp: boolean
    }
  }
}

export const generateCustomTokenMutationObject: GenerateCustomTokenMutationObject = {
  mutation: {
    generateCustomerToken: {
      __args: {
        email: '',
        password: '',
        persistent: false
      },
      token: true,
      expiration_date: true,
      expiration_timestamp: true
    }
  }
}

interface GenerateCustomTokenMutationInput {
  payload: {
    email: string
    password: string
    persistent?: boolean
  }
}

export type GenerateCustomTokenMutation = (input: GenerateCustomTokenMutationInput) => Promise<FetchResult<{ generateCustomerToken: GenerateCustomerTokenPayload }>>

export const createGenerateCustomTokenMutation = ({ getMutations }: ServiceDependencies): GenerateCustomTokenMutation => async ({ payload }) => {
  const { email, password, persistent } = payload

  const mutation = getMutations().generateCustomTokenMutation
  mutation.mutation.generateCustomerToken.__args.email = email
  mutation.mutation.generateCustomerToken.__args.password = password
  mutation.mutation.generateCustomerToken.__args.persistent = persistent ?? false

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
